import { decamelize } from '@ember/string';
import { isEmpty } from '@ember/utils';

export function decamelizeKeys(object: any) {
  let camelizedObject: any = {};
  for (let key of Object.keys(object)) {
    camelizedObject[decamelize(key)] = object[key];
  }
  return camelizedObject;
}

export default {
  decamelizeKeys: decamelizeKeys,
};

// uses Object.assign() to return a single property off the objects
export function assignSingleProperty(
  secondaryObject: any,
  primaryObject: any,
  property: string,
) {
  let primaryFragment: any = {};
  if (
    primaryObject.hasOwnProperty(property) ||
    primaryObject[property] !== undefined
  ) {
    primaryFragment[property] = primaryObject[property];
  }
  let secondaryFragment: any = {};
  // can't just use hasOwnProperty because it doesn't work with Ember Data Models
  if (
    secondaryObject.hasOwnProperty(property) ||
    secondaryObject[property] !== undefined
  ) {
    secondaryFragment[property] = secondaryObject[property];
  }
  return Object.assign({}, secondaryFragment, primaryFragment)[property];
}

// from https://stackoverflow.com/a/32108184
export function isEmptyObject(val: any) {
  if (typeof val !== 'object') {
    return false;
  }
  for (let prop in val) {
    if (Object.hasOwn(val, prop)) {
      return false;
    }
  }
  return true;
}

// a more robust version of Ember's isEmpty
// it checks for strings that are just whitespace
// and for objects that are empty
export function isNothing(val: any) {
  if (isEmpty(val)) {
    return true;
  }
  if (typeof val === 'string' && isEmpty(val.trim())) {
    return true;
  }
  if (typeof val === 'object' && isEmptyObject(val)) {
    return true;
  }
  return false;
}
